"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HorizontalNavigationFromConfig = _interopRequireDefault(require("./horizontal/HorizontalNavigationFromConfig"));
var _VerticalNavigationFromConfig = _interopRequireDefault(require("./vertical/VerticalNavigationFromConfig"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

/**
 * A navigation based on the navigation configuration
 */
var NavigationFromConfig = function NavigationFromConfig(_ref) {
  var config = _ref.config,
    vertical = _ref.vertical;
  return vertical ? _react["default"].createElement(_VerticalNavigationFromConfig["default"], {
    config: config
  }) : _react["default"].createElement(_HorizontalNavigationFromConfig["default"], {
    config: config
  });
};
var DropDownShape = {
  name: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};
NavigationFromConfig.propTypes = {
  config: _propTypes["default"].shape({
    env: _propTypes["default"].string.isRequired,
    loggedIn: _propTypes["default"].bool.isRequired,
    username: _propTypes["default"].string.isRequired,
    displayEnvIndicator: _propTypes["default"].bool.isRequired,
    usernameDropdownLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    navigationLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    logo: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    logoText: _propTypes["default"].string,
    builds: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      build: _propTypes["default"].string.isRequired
    })),
    tabletSupport: _propTypes["default"].bool
  }).isRequired,
  vertical: _propTypes["default"].bool
};
NavigationFromConfig.defaultProps = {
  vertical: false
};
var _default = NavigationFromConfig;
exports["default"] = _default;